import * as React from 'react';
import { Divider as MuiDivider } from '@mui/material';

export default function Divider({ sx, variant = "contained", textAlign = "center", label, ...other }) {
	return (
		<MuiDivider sx={sx} variant={variant} textAlign={textAlign} {...other}>{label}</MuiDivider>
	);
}
